import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'
//取得所有產線

let api = null
api = tools.mergeDeep(new ApiBase(), {
    SetSpecDeadLine(dateStr){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/SetSpecDeadLine',
            data: {
                specDeadLineTime: dateStr
            },
            method: 'post'
        })
    },
    GetSpecDeadLine(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetSpecDeadLine',
            data: null,
            method: 'post'
        })
    },
    GetUserInfoByAdmin(workCode){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/GetUserInfoByAdmin',
            data: {
                workCode
            },
            method: 'post'
        })
    },
    SetDateLock(turn){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/SetDateLock',
            data: {
                DateLock: turn
            },
            method: 'post'
        })
    },
    GetDateLock(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetDateLock',
            data: null,
            method: 'post'
        })
    },
    ADUnLock(employeeWorkCode){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/ADUnLock',
            data: {
                employeeWorkCode
            },
            method: 'post'
        })
    },
    ERPUnLock(workID, modifyUser) {
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/ERPUnLock',
            data: {
                workID,
                modifyUser
            },
            method: 'post'
        })
    },
    GetEmployees(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/GetEmployees',
            data: null,
            method: 'post'
        })
    },
    SetMaintenanceTime(dateStr){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/VueFrameApi/SetMaintenanceTime',
            data: {
                maintenanceTime: dateStr
            },
            method: 'post'
        })
    }
})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        SetSpecDeadLine(dateStr){
            return https({
                url: 'http://localhost:12345/VueFrameApi/SetSpecDeadLine',
                data: {
                    specDeadLineTime: dateStr
                },
                method: 'post'
            })
        },
        GetSpecDeadLine(){
            return https({
                url: 'http://localhost:12345/BookMeal/GetSpecDeadLine',
                data: null,
                method: 'post'
            })
        },
        GetUserInfoByAdmin(workCode){
            return https({
                url: 'http://localhost:12345/VueFrameApi/GetUserInfoByAdmin',
                data: {
                    workCode
                },
                method: 'post'
            })
        },
        SetDateLock(turn){
            return https({
                url: 'http://localhost:12345/VueFrameApi/SetDateLock',
                data: {
                    DateLock: turn
                },
                method: 'post'
            })
        },
        GetDateLock(){
            return https({
                url: 'http://localhost:12345/BookMeal/GetDateLock',
                data: null,
                method: 'post'
            })
        },
        ADUnLock(employeeWorkCode){
            return https({
                url: 'http://localhost:12345/VueFrameApi/ADUnLock',
                data: {
                    employeeWorkCode
                },
                method: 'post'
            })
        },
        ERPUnLock(workID, modifyUser) {
            return https({
                url: 'http://localhost:12345/VueFrameApi/ERPUnLock',
                data: {
                    workID,
                    modifyUser
                },
                method: 'post'
            })
        },
        GetEmployees(){
            return https({
                url: 'http://localhost:12345/VueFrameApi/GetEmployees',
                data: null,
                method: 'post'
            })
        },
        SetMaintenanceTime(dateStr){
            return https({
                url: 'http://localhost:12345/VueFrameApi/SetMaintenanceTime',
                data: {
                    maintenanceTime: dateStr
                },
                method: 'post'
            })
        }
    })
}

export default api